/**
 * @generated SignedSource<<ab2cd0c07802df5fd711d24e1c9e1677>>
 * @relayHash dee1f1969a38a7bdf53b990f40556252
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 42600e29d84634ed0c97f732eda8368f0b929877ee2b4331f73aa5e55c549042

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { GlobalBrandingQuery } from './GlobalBrandingQuery.graphql';

const node: PreloadableConcreteRequest<GlobalBrandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "42600e29d84634ed0c97f732eda8368f0b929877ee2b4331f73aa5e55c549042",
    "metadata": {},
    "name": "GlobalBrandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
